import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import sAuth from '@/services/sAuth';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  routes,
  mode: '',
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  store.dispatch('selectCategory', null);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // verify JWT token
    if (!sAuth.verifyToken()) {
      next({ path: '/' });
      sAuth.removeToken();
    } else {
      next();
    }
  } else if (sAuth.verifyToken()) {
    next({ path: '/my-account' });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js